import { LoadableAfterPaint } from '@confluence/loadable';

export const LegacyContentExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LegacyContentExtensionHandler" */ './LegacyContentExtensionHandler.tsx'
			)
		).LegacyContentExtensionHandler,
});
